import { useFeatureValue } from '@growthbook/growthbook-react';
import { HelpOutlineRounded, SupportAgentRounded } from '@mui/icons-material';
import { IconButton, Tooltip, Chip, Typography } from '@mui/material';
import { SupportButtonProps } from 'src/components/SupportButton/SupportButton.types';
import ProfileNavItem from 'src/features/profile/presentation/components/ProfileNavItem';
import { FEATURE_FLAGS } from 'src/utils/growthBook/growthBook.constants';

export default function SupportButton({
  color = 'default',
  variant = 'item',
  size = 'medium',
  hide,
}: SupportButtonProps) {
  const href = useFeatureValue(FEATURE_FLAGS.SUPPORT_LINK, '');
  const isItemVariant = variant === 'item';
  const isChipVariant = variant === 'chip';

  const handleClick = () => {
    window.open(href, '_blank', 'noopener,noreferrer');
  };

  if (hide) {
    return null;
  }

  if (isItemVariant) {
    return (
      <ProfileNavItem
        href={href}
        icon={<SupportAgentRounded />}
        title="Contactar a soporte"
        external
      />
    );
  }

  if (isChipVariant) {
    const chipBgColor = color === 'inherit' ? 'default' : color;

    return (
      <Chip
        icon={<HelpOutlineRounded />}
        label={
          <Typography
            color="inherit"
            variant="body1"
            lineHeight={1.5}
            fontWeight="fontWeightMedium"
          >
            Ayuda
          </Typography>
        }
        clickable
        onClick={handleClick}
        size="small"
        color={chipBgColor}
        sx={{
          px: 1,
          height: 32,
          pb: 0.2,
        }}
      />
    );
  }

  return (
    <Tooltip
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -14],
              },
            },
          ],
        },
      }}
      placement="left-start"
      arrow
      disableFocusListener
      disableTouchListener
      title="Contactar a soporte"
    >
      <IconButton onClick={handleClick} size={size} color={color}>
        <SupportAgentRounded fontSize={size} />
      </IconButton>
    </Tooltip>
  );
}
